module.exports = __webpack_public_path__ + "static/media/landing-top.394f3f9b.svg";